var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmShippmentBgImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 113,
    viewBox: "0 0 355 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 355,
    height: 113
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 355,
    height: 113,
    rx: 5,
    fill: "url(#paint0_linear_1_3)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.5 -9.5L282.5 22",
    stroke: "url(#paint1_linear_1_3)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.8611,
    y: -22,
    width: 82.8962,
    height: 116,
    rx: 10,
    transform: "rotate(50 12.8611 -22)",
    fill: "#CFF7CC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.861,
    y: 3,
    width: 82.8962,
    height: 116,
    rx: 10,
    transform: "rotate(50 401.861 3)",
    fill: "#D3F4F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7995,
    y: -51.2956,
    width: 81.8962,
    height: 115,
    rx: 9.5,
    transform: "rotate(50 12.7995 -51.2956)",
    stroke: "#BFEBBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3",
    x1: 0.999998,
    y1: 4.84285,
    x2: 361.301,
    y2: 42.9878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9FAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1F7FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3",
    x1: 295.352,
    y1: -15.2115,
    x2: 317.872,
    y2: 3.27519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8F1C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E9C0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmShippmentBgImg);
export default __webpack_public_path__ + "static/media/ConfirmShippmentBGImg.5fb8ccc27d8d219c07fe3feeaeb994f4.svg";
export { ForwardRef as ReactComponent };